import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/search.png'
import _imports_1 from '../images/mailbox.png'
import _imports_2 from '../images/clock.png'


const _withScopeId = n => (_pushScopeId("data-v-eeb66a36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-search-wrapper d-md-none" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "map-wrapper" }
const _hoisted_5 = { class: "search-wrapper" }
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = {
  id: "accordionWrapper",
  class: "accordion search-list"
}
const _hoisted_9 = ["id"]
const _hoisted_10 = ["data-bs-target", "onClick"]
const _hoisted_11 = { class: "title" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["id", "aria-labelledby"]
const _hoisted_14 = { class: "accordion-body" }
const _hoisted_15 = { class: "info-container" }
const _hoisted_16 = { class: "info-item" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "text" }
const _hoisted_19 = {
  key: 0,
  class: "info-item"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "text" }
const _hoisted_22 = {
  key: 1,
  class: "info-item"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "icon"
}, null, -1))
const _hoisted_24 = { class: "text" }
const _hoisted_25 = {
  key: 2,
  class: "info-item"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "icon"
}, null, -1))
const _hoisted_27 = { class: "text" }

import { reactive, ref, onMounted, watchEffect } from 'vue';
  import AppMap, { Location } from './google-map.vue';
  import _ from 'lodash';
  import { useI18n } from 'vue-i18n';
  import { loadScript } from 'vue-plugin-load-script';
  import { GOOGLE_MAP_API_URL } from '@/constants';

  interface IProps {
    locationList: Location[]
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    locationList: null
  },
  setup(__props: any) {

const props = __props as {
    locationList: Location[]
  }

  const { t } = useI18n();
  
  const searchLocationList = ref<Location[]>([]);
  const locationListSorted = ref<Location[]>([]);
  const collapse = reactive<{[propName: string]: boolean}>({});
  const keyword = ref('');
  const centerLocation = ref<Location>();
  const loadScriptPromise: Promise<any> = loadScript(GOOGLE_MAP_API_URL);;
  const mapLoaded = ref(false);
  const isJapan = process.env.VUE_APP_COUNTRY === 'ja';

  function handleTriggerCollapse(id: number, index: number) {
    const isOpen = !Boolean(collapse[id]);
    if (isOpen) {
      _.map(collapse, (val, key) => {
        collapse[key] = false;
      });
    }
    collapse[id] = isOpen;
    centerLocation.value = searchLocationList.value[index];
  };

  function handleSearch() {
    const locationList = locationListSorted.value;
    if (!keyword.value) {
      searchLocationList.value = locationList;
      centerLocation.value = locationList[0];
      return;
    }
    const list = locationList.filter((item => {
      return item.title.includes(keyword.value) || item.address.includes(keyword.value);
    }));
    searchLocationList.value = list.length ? list : locationList;
    centerLocation.value = searchLocationList.value[0];
  }

  onMounted(async () => {
    await loadScriptPromise;
    mapLoaded.value = true;
  });

  function getCurrentLocation(): Promise<{ lat: number; lng: number }> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position: GeolocationPosition) => {
            resolve({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
          },
          reject
        );
      } else {
        reject('浏览器不支持 navigator.geolocation');
      }
    });
  }

  async function sortLocationList() {
    const { locationList } = props;
    if (locationList.length) {
      try {
        const [userLocation] = await Promise.all([
          getCurrentLocation(),
          loadScriptPromise
        ]);
        locationListSorted.value = locationList
          .map(location => {
            return {
              ...location,
              distance: (location.lat && location.lng) ? google.maps.geometry.spherical.computeDistanceBetween({ lat: location.lat, lng: location.lng }, userLocation) : Number.MAX_SAFE_INTEGER
            };
          })
          .sort((a, b) => a.distance - b.distance);

        handleSearch();
        return;
      } catch (e) {}
    }
    locationListSorted.value = _.cloneDeep(props.locationList);
    handleSearch();
  }

  watchEffect(sortLocationList);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["offline-collection-point", { ja: isJapan }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        class: "mobile-search-input",
        onSubmit: _withModifiers(handleSearch, ["prevent"])
      }, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
          class: "input",
          placeholder: _unref(t)('offline_point_search_input_placeholder')
        }, null, 8, _hoisted_3), [
          [
            _vModelText,
            keyword.value,
            void 0,
            { trim: true }
          ]
        ]),
        _createElementVNode("img", {
          src: _imports_0,
          class: "icon",
          onClick: handleSearch
        })
      ], 40, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (mapLoaded.value && locationListSorted.value.length)
        ? (_openBlock(), _createBlock(AppMap, {
            key: 0,
            list: locationListSorted.value,
            "center-location": centerLocation.value
          }, null, 8, ["list", "center-location"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("form", {
        class: "search-input d-none d-md-block",
        onSubmit: _withModifiers(handleSearch, ["prevent"])
      }, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((keyword).value = $event)),
          class: "input",
          placeholder: _unref(t)('offline_point_search_input_placeholder')
        }, null, 8, _hoisted_7), [
          [
            _vModelText,
            keyword.value,
            void 0,
            { trim: true }
          ]
        ]),
        _createElementVNode("img", {
          src: _imports_0,
          class: "icon",
          onClick: handleSearch
        })
      ], 40, _hoisted_6),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchLocationList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "accordion-item"
          }, [
            _createElementVNode("div", {
              id: `panelsStayOpen-heading-${item.id}`,
              class: "accordion-header"
            }, [
              _createElementVNode("div", {
                class: "title-container",
                "data-bs-toggle": "collapse",
                "data-bs-target": `#collapse-${item.id}`,
                onClick: ($event: any) => (handleTriggerCollapse(item.id, index))
              }, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1),
                _createElementVNode("img", {
                  src: _unref(collapse)[item.id] ? require('../images/close.png') : require('../images/add.png'),
                  class: "icon"
                }, null, 8, _hoisted_12)
              ], 8, _hoisted_10)
            ], 8, _hoisted_9),
            _createElementVNode("div", {
              id: `collapse-${item.id}`,
              class: "accordion-collapse collapse",
              "aria-labelledby": `panelsStayOpen-heading-${item.id}`,
              "data-bs-parent": "#accordionWrapper"
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("img", {
                      src: (item.postal_code || item.opening_hours) ? require('../images/location.png') : require('../images/icon-location-active.png'),
                      class: _normalizeClass(["icon", { 'small-icon': item.postal_code || item.opening_hours }])
                    }, null, 10, _hoisted_17),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(item.address), 1)
                  ]),
                  (item.show_phone_on_map && item.phoneNumber)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("img", {
                          src: (item.postal_code || item.opening_hours) ? require('../images/phone.png') : require('../images/icon-phone-active.png'),
                          class: _normalizeClass(["icon", { 'small-icon': item.postal_code || item.opening_hours }])
                        }, null, 10, _hoisted_20),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(item.phoneNumber), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (item.postal_code)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("div", _hoisted_24, _toDisplayString(item.postal_code), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (item.opening_hours)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, _toDisplayString(item.opening_hours), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 8, _hoisted_13)
          ]))
        }), 128))
      ])
    ])
  ], 2))
}
}

})